<template>
	<div id="set-decision-matrix">
		<h3 class="line-header">Evaluation Decisions</h3>
		<p>
			Using the cumulative scores for Friendly and True Fraud, the final
			decision is mapped out for each likelihood.
		</p>
		<div
			class="decision-matrix"
			v-if="matrixButtons !== undefined && matrixButtons.length >= 9"
		>
			<div class="matrix-x-axis">
				<h3>Probability of Friendly Fraud</h3>
			</div>
			<div class="matrix-y-axis">
				<h3>Probability of True Fraud</h3>
			</div>

			<div :class="'matrix-buttons ' + (readOnly ? 'read-only' : '')">
				<div>
					<!-- make space for left label -->
				</div>
				<div>Low</div>
				<div>Medium</div>
				<div>High</div>

				<!-- row 1 -->
				<div class="rotate">High</div>
				<v-btn
					@click="onMatrixClick(6)"
					:class="matrixButtons[6].decision"
					>{{ matrixButtons[6].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(7)"
					:class="matrixButtons[7].decision"
					>{{ matrixButtons[7].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(8)"
					:class="matrixButtons[8].decision"
					>{{ matrixButtons[8].decision }}</v-btn
				>

				<!-- row 2 -->
				<div class="rotate">Medium</div>
				<v-btn
					@click="onMatrixClick(3)"
					:class="matrixButtons[3].decision"
					>{{ matrixButtons[3].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(4)"
					:class="matrixButtons[4].decision"
					>{{ matrixButtons[4].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(5)"
					:class="matrixButtons[5].decision"
					>{{ matrixButtons[5].decision }}</v-btn
				>

				<!-- row 3 -->
				<div class="rotate">Low</div>
				<v-btn
					@click="onMatrixClick(0)"
					:class="matrixButtons[0].decision"
					>{{ matrixButtons[0].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(1)"
					:class="matrixButtons[1].decision"
					>{{ matrixButtons[1].decision }}</v-btn
				>
				<v-btn
					@click="onMatrixClick(2)"
					:class="matrixButtons[2].decision"
					>{{ matrixButtons[2].decision }}</v-btn
				>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @fileoverview decision-matrix.vue displays the decision matrix with friendly fraud on the x axis and true fraud on the y axis.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from "vuex";

	export default {
		name: "setDecisionMatrix",
		props: {
			/**
			 * True if the matrix cannot be modified
			 */
			readOnly: {
				type: Boolean,
				default: false,
			},
			/**
			 * Button click function
			 */
			onMatrixClick: {
				type: Function,
				default: function () {
					return null;
				},
			},
		},
		data() {
			return {
				statusList: ["Pay", "Refer", "Deny"],	// Button status options
			};
		},
		computed: {
			...mapState({
				matrixButtons: (state) => state.config.decisionMatrix,
			}),
		},
	};
</script>

<!-- Styles defined in _setDecisionMatrix.scss -->
